/**
 * Project Slideshow — Splide initialization
 *
 * Two synced Splide instances per block: a main 1-per-page slider
 * and a thumbnail strip navigation. Structural CSS comes from
 * `assets/css/vendor/splide-core.min.css`; visual styling lives
 * in `src/scss/blocks/_project-slideshow.scss`.
 */

import Splide from '@splidejs/splide';

function initProjectSlideshows() {
	const blocks = document.querySelectorAll( '.corsa-project-slideshow:not(.is-editor-preview)' );

	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( block ) => {
		const mainEl   = block.querySelector( '.corsa-project-slideshow__main' );
		const thumbsEl = block.querySelector( '.corsa-project-slideshow__thumbs' );

		if ( ! mainEl || ! thumbsEl ) {
			return;
		}

		const isLoop = mainEl.dataset.loop === '1';

		const main = new Splide( mainEl, {
			type:       isLoop ? 'loop' : 'slide',
			perPage:    1,
			perMove:    1,
			gap:        0,
			arrows:     true,
			pagination: false,
			drag:       true,
		} );

		const thumbs = new Splide( thumbsEl, {
			type:         'slide',
			fixedWidth:   179,
			fixedHeight:  145,
			gap:          19,
			arrows:       false,
			pagination:   false,
			isNavigation: true,
			focus:        'center',
			cover:        true,
			breakpoints: {
				1024: { fixedWidth: 140, fixedHeight: 114, gap: 12 },
				640:  { fixedWidth: 96,  fixedHeight: 78,  gap: 8 },
			},
		} );

		main.sync( thumbs );
		main.mount();
		thumbs.mount();
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initProjectSlideshows );
} else {
	initProjectSlideshows();
}
